(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PortDialogController', PortDialogController);

    PortDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Port', 'Country', 'CountryCustomService'];

    function PortDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Port, Country, CountryCustomService) {
        var vm = this;

        vm.port = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        CountryCustomService.returnAllCountries().then(function(countries) {
            vm.countries = countries.data
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.port.id !== null) {
                Port.update(vm.port, onSaveSuccess, onSaveError);
            } else {
                Port.save(vm.port, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:portUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdOn = false;
        vm.datePickerOpenStatus.modifiedOn = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
